angular.module 'app'
.config ($stateProvider) ->
  $stateProvider
    .state 'app.file-manage',
      url: '/file-manage'
      templateUrl: 'apps/file-manage/file-manage'
      controller: 'FileManageCtrl'
